/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { connectorCopyPublicItemsFiles } from '../fn/apollon-connector/connector-copy-public-items-files';
import { ConnectorCopyPublicItemsFiles$Params } from '../fn/apollon-connector/connector-copy-public-items-files';
import { connectorGetContacts } from '../fn/apollon-connector/connector-get-contacts';
import { ConnectorGetContacts$Params } from '../fn/apollon-connector/connector-get-contacts';
import { connectorGetItemTypes } from '../fn/apollon-connector/connector-get-item-types';
import { ConnectorGetItemTypes$Params } from '../fn/apollon-connector/connector-get-item-types';
import { connectorGetPublicItems } from '../fn/apollon-connector/connector-get-public-items';
import { ConnectorGetPublicItems$Params } from '../fn/apollon-connector/connector-get-public-items';
import { connectorGetPublicSeries } from '../fn/apollon-connector/connector-get-public-series';
import { ConnectorGetPublicSeries$Params } from '../fn/apollon-connector/connector-get-public-series';
import { connectorGetSeriesTypes } from '../fn/apollon-connector/connector-get-series-types';
import { ConnectorGetSeriesTypes$Params } from '../fn/apollon-connector/connector-get-series-types';
import { connectorGetTagsAndGroups } from '../fn/apollon-connector/connector-get-tags-and-groups';
import { ConnectorGetTagsAndGroups$Params } from '../fn/apollon-connector/connector-get-tags-and-groups';
import { PublicContact } from '../models/public-contact';
import { PublicItemType } from '../models/public-item-type';
import { PublicItemWithRelations } from '../models/public-item-with-relations';
import { PublicSeries } from '../models/public-series';
import { PublicSeriesType } from '../models/public-series-type';
import { PublicTagAndGroupResponse } from '../models/public-tag-and-group-response';

@Injectable({ providedIn: 'root' })
export class ApollonConnectorService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apollonConnectorControllerConnectorGetContacts()` */
  static readonly ApollonConnectorControllerConnectorGetContactsPath = '/apollon-connector/enums/contacts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `connectorGetContacts()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorGetContacts$Response(params: ConnectorGetContacts$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PublicContact>>> {
    return connectorGetContacts(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `connectorGetContacts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorGetContacts(params: ConnectorGetContacts$Params, context?: HttpContext): Observable<Array<PublicContact>> {
    return this.connectorGetContacts$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PublicContact>>): Array<PublicContact> => r.body)
    );
  }

  /** Path part for operation `apollonConnectorControllerConnectorGetItemTypes()` */
  static readonly ApollonConnectorControllerConnectorGetItemTypesPath = '/apollon-connector/enums/item-types';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `connectorGetItemTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorGetItemTypes$Response(params?: ConnectorGetItemTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PublicItemType>>> {
    return connectorGetItemTypes(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `connectorGetItemTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorGetItemTypes(params?: ConnectorGetItemTypes$Params, context?: HttpContext): Observable<Array<PublicItemType>> {
    return this.connectorGetItemTypes$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PublicItemType>>): Array<PublicItemType> => r.body)
    );
  }

  /** Path part for operation `apollonConnectorControllerConnectorGetSeriesTypes()` */
  static readonly ApollonConnectorControllerConnectorGetSeriesTypesPath = '/apollon-connector/enums/series-types';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `connectorGetSeriesTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorGetSeriesTypes$Response(params?: ConnectorGetSeriesTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PublicSeriesType>>> {
    return connectorGetSeriesTypes(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `connectorGetSeriesTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorGetSeriesTypes(params?: ConnectorGetSeriesTypes$Params, context?: HttpContext): Observable<Array<PublicSeriesType>> {
    return this.connectorGetSeriesTypes$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PublicSeriesType>>): Array<PublicSeriesType> => r.body)
    );
  }

  /** Path part for operation `apollonConnectorControllerConnectorGetTagsAndGroups()` */
  static readonly ApollonConnectorControllerConnectorGetTagsAndGroupsPath = '/apollon-connector/enums/tags-and-groups';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `connectorGetTagsAndGroups()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorGetTagsAndGroups$Response(params: ConnectorGetTagsAndGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<PublicTagAndGroupResponse>> {
    return connectorGetTagsAndGroups(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `connectorGetTagsAndGroups$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorGetTagsAndGroups(params: ConnectorGetTagsAndGroups$Params, context?: HttpContext): Observable<PublicTagAndGroupResponse> {
    return this.connectorGetTagsAndGroups$Response(params, context).pipe(
      map((r: StrictHttpResponse<PublicTagAndGroupResponse>): PublicTagAndGroupResponse => r.body)
    );
  }

  /** Path part for operation `apollonConnectorControllerConnectorCopyPublicItemsFiles()` */
  static readonly ApollonConnectorControllerConnectorCopyPublicItemsFilesPath = '/apollon-connector/items/files/copy';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `connectorCopyPublicItemsFiles()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  connectorCopyPublicItemsFiles$Response(params?: ConnectorCopyPublicItemsFiles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<{
'id'?: string;
'message'?: string;
}>>> {
    return connectorCopyPublicItemsFiles(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `connectorCopyPublicItemsFiles$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  connectorCopyPublicItemsFiles(params?: ConnectorCopyPublicItemsFiles$Params, context?: HttpContext): Observable<Array<{
'id'?: string;
'message'?: string;
}>> {
    return this.connectorCopyPublicItemsFiles$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<{
'id'?: string;
'message'?: string;
}>>): Array<{
'id'?: string;
'message'?: string;
}> => r.body)
    );
  }

  /** Path part for operation `apollonConnectorControllerConnectorGetPublicItems()` */
  static readonly ApollonConnectorControllerConnectorGetPublicItemsPath = '/apollon-connector/items';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `connectorGetPublicItems()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorGetPublicItems$Response(params: ConnectorGetPublicItems$Params, context?: HttpContext): Observable<StrictHttpResponse<PublicItemWithRelations>> {
    return connectorGetPublicItems(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `connectorGetPublicItems$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorGetPublicItems(params: ConnectorGetPublicItems$Params, context?: HttpContext): Observable<PublicItemWithRelations> {
    return this.connectorGetPublicItems$Response(params, context).pipe(
      map((r: StrictHttpResponse<PublicItemWithRelations>): PublicItemWithRelations => r.body)
    );
  }

  /** Path part for operation `apollonConnectorControllerConnectorGetPublicSeries()` */
  static readonly ApollonConnectorControllerConnectorGetPublicSeriesPath = '/apollon-connector/series';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `connectorGetPublicSeries()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorGetPublicSeries$Response(params: ConnectorGetPublicSeries$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PublicSeries>>> {
    return connectorGetPublicSeries(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `connectorGetPublicSeries$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  connectorGetPublicSeries(params: ConnectorGetPublicSeries$Params, context?: HttpContext): Observable<Array<PublicSeries>> {
    return this.connectorGetPublicSeries$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PublicSeries>>): Array<PublicSeries> => r.body)
    );
  }

}
